import React from "react"

const placeFields = (autocomplete) =>
{        
    const names = []    
    const place = autocomplete.getPlace()
    const fields = ['place_id','address_components','formatted_address']

    const addID = () =>
    {
        if(place.place_id) names.push(['place_id',place.place_id]) 
    }

    const formatted = () =>
    {
        if(place.formatted_address)
        {
            const street = place.formatted_address.split(',')  
            
            if(street.length > 0) 
            {
                names.push(['street',street[0]])                               
                street.shift()
                names.push(['street2',street.join().trim()]) 
            }
        }
    }

    const components = () =>
    {
        if(place.address_components)
        {
            const search = ['postal_code','locality','country','administrative_area_level_1']
            
            const address = place.address_components
            
            Object.keys(address).map((index) => 
            {
                let key = address[index].types[0]   
                const value = address[index].long_name                                    

                search.map(name =>
                {
                    if(name === key)
                    {
                        switch(key)
                        {
                            case 'administrative_area_level_1': key = 'state'; break
                        }

                        names.push([key,value])         
                    }
                })
            })
        } 
    }

    const getFields = () =>
    {             
        fields.map(fiel =>
        {                
            switch(fiel)
            {
                case 'place_id': addID(); break
                case 'formatted_address': formatted(); break                
                case 'address_components': components(); break
            }
        })

        return names
    }

    return getFields()    
}    

export default placeFields